const paths = {
  configuration: [
    process.env.REACT_APP_CONFIGURL,
    "https://kookoo-config-default-rtdb.firebaseio.com/config-license.json",
  ],
  locate: "/locate",
  login: "/login",
  logout: "/logout",
  signup: "/subscriber/subscribe",
  checkEmail: "/subscriber/emailprecheck",
  profiles: "/profile",
  plans: "/userplan",
  contact: "/api/contact",
  forgotpassword: "/passwordreset",
  deliveryaddress: "/api/deliveryaddress",
  orderApi: "/payment/init",
  paymentAck: "/payment/callback",
  paymentverification: "/payment/verifypayment",
  contents: "/content",
  contentCount: "/content/count",
  updateSubscriber: "/subscriber",
  getSubscriber: "/subscriber",
  razarpay: "https://checkout.razorpay.com/v1/checkout.js",
  paytm:"https://securegw.paytm.in/merchantpgpui/checkoutjs/merchants/GFXBTF65238186523841.js",
  googleScript: "https://apis.google.com/js/api.js",
  facebookScript: "https://connect.facebook.net/en_US/sdk.js",
  appleScript:
    "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js",
  fetchAvatars: "/content/castncrew",
  token: "/token",
  listMerchandise: "/merchandise",
  coupon:'/coupon',
  downloadWorksheet: "/worksheet",
  rewards: '/completionevent',
  contact:"/notify",
  pincode:'/locate/postoffice',
  testcancelplan: '/subscriber/cancelsubscription',
  downloadMilestoneReport:'/milestone',
  downloadMilestoneReportpdf:'/milestone/download',
};

export { paths };
